import React from 'react';
import { connect } from 'react-redux';
import cls from 'classnames';

import { getMenuAct } from 'model/actions/LoginAction';
import { Main } from './styled';
import Logo from '../Logo';
import { MERCHANT } from 'constants/index';
import { AppRoutes } from 'constants/appRoutes';
import { useNavigate } from 'react-router-dom';

const HeaderResponsive = ({
	isPartnerLink,
	merchantCode,
	insurranceOnlineRed,
}) => {
	const navigate = useNavigate();
	const logoMerchant = insurranceOnlineRed.merchantData.obj?.logoDesktopFile;


	const isHeaderFull =
		logoMerchant &&
		[
			MERCHANT.viettelStore,
			MERCHANT.viettelPost,
			MERCHANT.bvSmart,
			MERCHANT.momo,
		].includes(merchantCode);

	return (
		<Main>
			<div
				className={cls({
					'main-header-path': isPartnerLink,
					// "main-header-path": isHeaderFull,
					// "main-header-path": !isHeaderFull,
				})}
			>
				<div className='header-responsive'>
					{logoMerchant && (
						<Logo
							className={'logo-responsive'}
							imgUrl={`data:image/jpeg;base64,${logoMerchant}`}
						/>
					)}
					{isPartnerLink ? (
						<img
							onClick={() => navigate(AppRoutes.home)}
							className={'logo-responsive cursor-pointer'}
							src='/logo/bao-viet-nhan-tho.png'
							alt=''
							width={123}
						/>
					 ) : (
						<img
							onClick={() => navigate(AppRoutes.home)}
							className={'logo-responsive cursor-pointer'}
							src='/logo/ePos-moblie.png'
							alt=''
							width={190}
						/> 
					)} 
				</div>
			</div>
		</Main>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		navigation: state.navigation,
		config: state.config,
		loginRed: state.LoginReducer,
		functionSupportRed: state.FunctionSupportReducer,
		insurranceOnlineRed: state.InsurranceOnlineReducer,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getMenuAct: () => dispatch(getMenuAct()),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(HeaderResponsive);
